import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { toast } from "sonner";
import { forgotPassword } from "../lib/api";
import { useT } from "../lib/i18n";

export default function ForgotPassword() {
  const { t, lang } = useT();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email, lang);
      setSent(true);
      toast.success(t("toast.reset_sent"));
    } catch {
      // Never reveal whether the email exists. Always show the same message.
      setSent(true);
      toast.success(t("toast.reset_sent"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBFBFD]">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-white/70 border-b border-[#E8E8ED]">
        <div className="max-w-md mx-auto px-4 md:px-6 h-14 flex items-center gap-3">
          <Link to="/login" className="p-2 -ml-2 rounded-full hover:bg-[#F5F5F7]" data-testid="forgot-back-btn">
            <ArrowLeft className="w-5 h-5 text-[#0A2540]" />
          </Link>
          <div className="font-semibold text-[#0A2540]">{t("forgot.title")}</div>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 md:px-6 py-8">
        <div className="flex flex-col items-center mb-6">
          <img src="/taip-logo.png" alt="TAi-P" className="w-20 h-20 object-contain" />
          <div className="text-sm text-gray-500 mt-2 text-center">{t("forgot.desc")}</div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="text-xs text-gray-500">{t("login.email")}</label>
            <div className="relative mt-1">
              <Mail className="w-4 h-4 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input
                data-testid="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                placeholder="anda@email.com"
                className="w-full pl-10 pr-4 py-3 rounded-full bg-white border border-[#E8E8ED] focus:border-[#4FB3E8] outline-none text-sm"
              />
            </div>
          </div>
          <button
            data-testid="forgot-submit-btn"
            type="submit"
            disabled={busy || sent}
            className="w-full py-3 rounded-full bg-[#0A2540] hover:bg-[#0A2540]/90 text-white font-medium transition-colors disabled:opacity-60"
          >
            {busy ? (lang === "en" ? "Sending…" : "Menghantar…") : t("forgot.submit")}
          </button>
        </form>

        {sent && (
          <p data-testid="forgot-sent-msg" className="text-sm text-gray-500 mt-4 text-center">
            {t("toast.reset_sent")}
          </p>
        )}

        <div className="text-center text-sm text-gray-500 mt-6">
          <Link to="/login" className="text-[#4FB3E8] font-medium">{t("forgot.back_login")}</Link>
        </div>
      </main>
    </div>
  );
}
